import type { SVGProps } from 'react';

const Addendum = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M6.66683 13.1022V13.1116H6.67572M8.3335 1.66699H4.5835C3.8935 1.66699 3.3335 2.2581 3.3335 2.98644V16.1809C3.3335 16.9092 3.8935 17.5003 4.5835 17.5003H15.4168C16.1068 17.5003 16.6668 16.9092 16.6668 16.1809V2.98644C16.6668 2.2581 16.1068 1.66699 15.4168 1.66699H8.3335ZM6.66683 6.06514H6.67572V6.07452H6.66683V6.06514Z"
      stroke="#111927"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default Addendum;
